module.exports = __webpack_public_path__ + "static/media/background-3.a3bfa566.jpg";